import { createAction, props } from '@ngrx/store';
import { DsrActivity, DsrPayform, LinehaulSchedule, Note } from '@xpo-ltl/sdk-linehaulpayform';
import { ActionPatchData, PayformState } from '../app.state';

interface SetPayformStateProps {
  payform: PayformState;
}

interface SetCurrentPayformProps {
  current: DsrPayform;
}

interface SetPayformReadOnlyProps {
  readOnly: boolean;
}

interface EditPayformActivityProps {
  actvtySequenceNbr?: string;
  activity?: DsrActivity;
  schSequenceNbr?: string;
}

interface EditPayformCommentProps {
  comment: Note;
}

interface EditPayformScheduleProps {
  schedule?: LinehaulSchedule;
  schSequenceNbr?: string;
  patchData?: ActionPatchData;
}

export const setPayformStateAction = createAction('[Payform] Set payform state', props<SetPayformStateProps>());

export const setCurrentPayformAction = createAction('[Payform] Set current payform', props<SetCurrentPayformProps>());

export const resetPayformStateAction = createAction('[Payform] Reset payform state');

export const setPayformReadOnlyAction = createAction('[Payform] Set payform read only', props<SetPayformReadOnlyProps>());

export const editPayformActivityAction = createAction('[Payform] Edit payform activity', props<EditPayformActivityProps>());

export const editPayformCommentAction = createAction('[Payform] Edit payform comment', props<EditPayformCommentProps>());

export const editPayformScheduleAction = createAction('[Payform] Edit payform schedule', props<EditPayformScheduleProps>());
